import { Drawer as DrawerPrimitive } from "vaul";
import { ComponentProps, FC } from "react";

import { TDrawerRootProps } from "./Drawer.config";
import { DrawerContent } from "./DrawerContent";
import { DrawerHeader } from "./DrawerHeader";
import { DrawerTitle } from "./DrawerTitle";
import { DrawerDescription } from "./DrawerDescription";
import { DrawerChildren } from "./DrawerChildren";
import { DrawerFooter } from "./DrawerFooter";

export const Drawer: FC<TDrawerRootProps> = (
  {
    title,
    description,
    children,
    footer,
    shouldScaleBackground = false,
    ...props
  },
) => (
  <DrawerPrimitive.Root
    direction="bottom"
    shouldScaleBackground={shouldScaleBackground}
    // vaul's root props are a discriminated union (snapPoints/fadeFromIndex),
    // so the spread of our rest props needs a cast to satisfy it.
    {...(props as ComponentProps<typeof DrawerPrimitive.Root>)}
  >
    <DrawerContent {...(description ? {} : { "aria-describedby": undefined })}>
      <DrawerHeader>
        <DrawerTitle>{ title }</DrawerTitle>
        { description ? (
          <DrawerDescription>{ description }</DrawerDescription>
        ) : null }
      </DrawerHeader>
      <DrawerChildren>
        { children }
      </DrawerChildren>
      <DrawerFooter {...footer} />
    </DrawerContent>
  </DrawerPrimitive.Root>
);

Drawer.displayName = "Drawer";
